import { jsx } from "react/jsx-runtime";
import React from "react";
import { DatePickerHeaderCustom } from "./ui/DatePickerHeaderCustom";
import { PickersDayWeekDate } from "./ui/PickersDayWeekDate";
import { CALENDAR_TYPE } from "../model";
const useDateCalendarSlots = (type, props) => {
  const [hoveredDay, setHoveredDay] = React.useState(null);
  const calendarPickerSlots = React.useMemo(() => {
    return {
      calendarHeader: DatePickerHeaderCustom,
      ...(type === CALENDAR_TYPE.week || type === CALENDAR_TYPE.month) && { day: (props2) => /* @__PURE__ */ jsx(PickersDayWeekDate, { viewType: type, ...props2 }) },
      ...props.slots
    };
  }, [type, props.slots]);
  const calendarPickerSlotsProps = React.useMemo(() => {
    if (type === CALENDAR_TYPE.single)
      return {
        ...props.slotProps
      };
    if (type === CALENDAR_TYPE.week || type === CALENDAR_TYPE.month)
      return {
        day: (ownerState) => ({
          selectedDay: props.value,
          hoveredDay,
          onPointerEnter: () => setHoveredDay(ownerState.day),
          onPointerLeave: () => setHoveredDay(null)
        }),
        popper: { disablePortal: true },
        ...props.slotProps
      };
    return {};
  }, [type, props.slotProps, props.value, hoveredDay]);
  return {
    calendarPickerSlots,
    calendarPickerSlotsProps
  };
};
export {
  useDateCalendarSlots
};
